import { BaseModel, EntityProperty } from '@tcc-mono/shared/data-access';
import { Animal, PurchaseOrderAnimal } from '@tcc-mono/vandijk/shared/data-access/models';
import dayjs from 'dayjs';
export class PurchaseOrder extends BaseModel {
  id: number;
  animal_count: number;
  closed: boolean;
  created_at: string;
  date: string;
  hub_id: number;
  order_number: string;
  relation_id: number;
  relation_name: string;
  total_price: string;
  bright_exported_at: string;
  animals?: PurchaseOrderAnimal[];
  properties?: EntityProperty[];
  ride_id: null;
  ride_kvs_ride_id: null;
  ride_kvs_closed_at: string;
  ride_kvs_ride_number: null;
  ride_license_plate: null;
  invoiced: boolean;
  kvs_closed_at: string;
  twaka_exported_at: string;
  tcs_exported_at: string;
  relation_has_twaka: boolean;
  relation_has_tcs: boolean;

  mail_status_bright?: string;
  mail_status_purchase_order_pdf?: string;
  mail_status_tcs?: string;
  kvs_error?: string[];

  public constructor(po?: Partial<PurchaseOrder>) {
    super();
    this.id = po?.id;
    this.animal_count = po?.animal_count || 0;
    this.closed = po?.closed || false;
    this.date = po?.date || dayjs().format('YYYY-MM-DD HH:mm:ss');
    this.created_at = po?.created_at;
    this.hub_id = po?.hub_id;
    this.order_number = po?.order_number;
    this.relation_id = po?.relation_id;
    this.relation_name = po?.relation_name;
    this.total_price = po?.total_price;
    this.bright_exported_at = po?.bright_exported_at;
    this.animals = [];
    this.properties = po?.properties;
    this.kvs_closed_at = po?.kvs_closed_at;
  }
}
